import React, { forwardRef } from 'react';
import cn from 'classnames';
import SvgIcon from '../../../common/SvgIcon';
import { REASONS } from '../../../common/constants/brief';

const GettingStartedReason = (
  { value, invalid, proPlatform, className, onChange, children },
  ref,
) => (
  <div ref={ref} className={cn('tab', className)}>
    <div className="tab_question">{`Question 1 of ${proPlatform ? '5' : '7'}`}</div>
    <div className="tab_tag">
      <SvgIcon icon="icon-question-step-1" />
    </div>
    <div className="tab_title">
      <div className={cn('-bold', { 'has-error -error-position-right': invalid })}>
        Select the main reason(s) you wish to redesign your space?
        {invalid && <div className="form-error">please, choose your reason(s)</div>}
      </div>
    </div>
    <div className="getting-started_tags">
      {REASONS.map(reason => (
        <div
          key={reason}
          role="getting-started_tag"
          className={cn('getting-started_tag', { '-active': value.includes(reason) })}
          onClick={() => onChange(reason)}
        >
          {reason}
        </div>
      ))}
    </div>
    {children}
  </div>
);

export default forwardRef(GettingStartedReason);



// WEBPACK FOOTER //
// ./app/javascript/components/getting_started/components/GettingStartedReason.js